/* eslint-disable import/prefer-default-export */
export enum SellerStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Repproved = 'REPROVED',
}
